module.exports = __webpack_public_path__ + "img/rolling_on_the_floor_laughing.e00d351d.gif";